// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* jsPanels */
.jsPanel, .jsPanel-hdr, .jsPanel-content {
  font-family: var(--graphileon-font-family);
}

.jsPanel-titlebar {
  min-height: 1.5rem;
}

.jsPanel-titlebar .jsPanel-title {
  font-variant: inherit;
}

/* Configurable header button (\$container.menu). Added to the header bar as a regular
   button rather than a jsPanel header control, so it stays visible when the window
   controls are hidden. \`flex: 0 0 auto\` keeps it from being squeezed by the title bar. */
.jsPanel-headerbar .container-menu-button {
  flex: 0 0 auto;
  white-space: nowrap;
  color: inherit;
}

.jsPanel-content .container-content {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
}

#jsPanel-replacement-container {
  background-color: var(--graphileon-color);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  border-radius: 0.375rem;
}

#jsPanel-replacement-container .jsPanel-replacement {
  margin-top: 0rem;
  margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./apps/default/containers/container-content.scss"],"names":[],"mappings":"AAAA,aAAA;AAEA;EACC,0CAAA;AAAD;;AAEA;EACC,kBAAA;AACD;;AACA;EACC,qBAAA;AAED;;AACA;;yFAAA;AAGA;EACC,cAAA;EACA,mBAAA;EACA,cAAA;AAED;;AACA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAED;;AAAA;EACC,yCAAA;EACA,uCAAA;EACA,uBAAA;AAGD;;AADA;EACC,gBAAA;EACA,kBAAA;AAID","sourcesContent":["/* jsPanels */\n\n.jsPanel, .jsPanel-hdr, .jsPanel-content {\n\tfont-family: var(--graphileon-font-family);\n}\n.jsPanel-titlebar {\n\tmin-height: 1.5rem;\n}\n.jsPanel-titlebar .jsPanel-title {\n\tfont-variant: inherit;\n}\n\n/* Configurable header button ($container.menu). Added to the header bar as a regular\n   button rather than a jsPanel header control, so it stays visible when the window\n   controls are hidden. `flex: 0 0 auto` keeps it from being squeezed by the title bar. */\n.jsPanel-headerbar .container-menu-button {\n\tflex: 0 0 auto;\n\twhite-space: nowrap;\n\tcolor: inherit;\n}\n\n.jsPanel-content .container-content {\n\theight: 100%;\n\twidth: 100%;\n\tposition: relative;\n\toverflow: auto;\n}\n#jsPanel-replacement-container {\n\tbackground-color: var(--graphileon-color);\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n\tborder-radius: 0.375rem;\n}\n#jsPanel-replacement-container .jsPanel-replacement {\n\tmargin-top: 0rem;\n\tmargin-right: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
